import styled from 'styled-components';

const Section = styled.div`
    padding: 8px 0;
`;

export default Section;



// WEBPACK FOOTER //
// ./app/containers/FastCover/components/Section/index.js